import { differenceInWeeks, distanceInWordsStrict, isAfter } from 'date-fns';

import { pluralize } from '@zapier/common-utils';

import { Dateable, TimeSpanFormatter } from '../types';

const formatTimeSpan: TimeSpanFormatter = (
  endDate: Dateable,
  startDate: Dateable,
  addSuffix = true
) => {
  // `distanceInWords` does not support weeks resolution
  const weeks = Math.abs(differenceInWeeks(endDate, startDate));
  if (weeks > 0 && weeks < 4) {
    const isEndAfter = isAfter(startDate, endDate);
    const prefix = addSuffix && isEndAfter ? 'in ' : '';
    const suffix = addSuffix && !isEndAfter ? ' ago' : '';
    return `${prefix}${weeks} ${pluralize('week', weeks)}${suffix}`;
  }

  return distanceInWordsStrict(endDate, startDate, { addSuffix });
};

export default formatTimeSpan;
